/**
 * Converts a dot notation string to kebab case.
 * Replaces dots ('.') with dashes ('-'), converts camelCase to kebab-case,
 * and lowercases the entire string.
 *
 * @param value The dot notation string to convert.
 * @returns The converted kebab case string.
 */
export function dotToKebab(value: string): string {
    return value
        .replace(/\./g, '-') // Replace dots with dashes
        .replace(/([a-z0-9])([A-Z])/g, '$1-$2') // Add dash before capital letters
        .toLowerCase(); // Convert to lowercase
}
